import { IFieldInstance } from "../../types/fieldInstance.interface";
import {
  getRLFormFields,
  incidentRelatedLists,
  transformedInlineRLFields,
} from "../helpers/relatedListHelpers";
import { shouldFieldRender } from "./viewModelMethods";

// if field is false, rl is false too, if field is true, generate a schema
export const createRLHashTable = (inputObject: {
  [x: string]: IFieldInstance[];
}) => {
  const hashTable: {
    [x: string]: IFieldInstance;
  } = {};
  for (let key in inputObject) {
    for (let field of inputObject[key]) {
      let id = field.id;
      if (!hashTable[id]) {
        hashTable[id] = field;
      }
    }
  }
  return hashTable;
};

export const getRLViewModel = (mainFieldName: string, values: any) => {
  const formFields = getRLFormFields(mainFieldName);
  const inlineRLFields = Object.keys(transformedInlineRLFields).map(
    (field) => incidentRelatedLists[field]
  );
  if (inlineRLFields.includes(mainFieldName)) {
    return;
  }
  const fieldArrayViewModel = (values[mainFieldName] || []).map(
    (value: any) => {
      const rLViewModel: any = {};
      const rlHashTable = createRLHashTable(formFields);
      const findFieldById = (id: string, hashObject: any = rlHashTable) => {
        return hashObject[id] || null;
      };
      Object.values(formFields)
        .flat()
        .forEach((field: any) => {
          if (!rLViewModel[field.id]) {
            rLViewModel[field.id] = shouldFieldRender(
              field,
              value,
              findFieldById
            );
          }
        });
      return rLViewModel;
    }
  );
  return fieldArrayViewModel;
};

export const getAllRLViewModels = (rlFields: any, values: any) => {
  const rlViewModelObj: any = {};
  Object.keys(rlFields).forEach((rlFieldKey) => {
    const rlViewModel = getRLViewModel(rlFields[rlFieldKey], values);
    if (!rlViewModelObj[rlFieldKey]) {
      rlViewModelObj[rlFieldKey] = rlViewModel;
    }
  });
  return rlViewModelObj;
};

export const getActiveRLViewModels = (
  rlFields: any,
  rlViewModel: any,
  values: any
) => {
  return Object.keys(rlViewModel).reduce((acc: any, key) => {
    const field = rlFields[key];
    const activeValue = values[field];
    let viewModel = rlViewModel[key];
    if (
      activeValue[0]?.index !== undefined &&
      viewModel &&
      viewModel.length > 0
    ) {
      viewModel = viewModel[activeValue[0].index];
    }
    acc[key] = viewModel;
    return acc;
  }, {});
};
